import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/i18n";
import { money } from "@/lib/constants";

// Publieke pagina na het betalen: polst de status tot Stripe de betaling bevestigt.
export default function BetalingOk() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState(params.get("paid") ? { payment_status: "paid" } : null);
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sid || state?.payment_status === "paid" || tries > 20) return;
    const timer = setTimeout(async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        setState(data);
      } catch (e) { console.debug("Betaalstatus nog niet beschikbaar", e?.message); }
      setTries((n) => n + 1);
    }, 2000);
    return () => clearTimeout(timer);
  }, [sid, state, tries]);

  const paid = state?.payment_status === "paid";
  const failed = ["failed", "expired"].includes(state?.payment_status);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="payment-result">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        {paid ? <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-600" data-testid="payment-ok-icon" />
          : failed ? <XCircle className="mx-auto h-14 w-14 text-rose-500" />
            : <Loader2 className="mx-auto h-14 w-14 animate-spin text-sky-600" />}
        <h1 className="mt-5 font-display text-2xl font-bold text-slate-900">
          {paid ? t("payment_ok_title") : failed ? t("payment_failed_title") : t("payment_pending_title")}
        </h1>
        <p className="mt-2 text-sm text-slate-600">
          {paid ? t("payment_ok_text") : failed ? t("payment_failed_text") : t("payment_pending_text")}
        </p>
        {paid && state?.amount ? (
          <p className="mt-3 font-display text-xl font-bold text-emerald-700" data-testid="payment-amount">
            {money(state.amount)}
          </p>
        ) : null}
        <Link to="/" className="mt-6 inline-block text-sm font-semibold text-sky-700 hover:underline" data-testid="payment-home-link">
          {t("back")}
        </Link>
      </div>
    </div>
  );
}
